import React, { FC } from 'react';
import Modal from './common/Modal/Modal';

interface ModalApprovalFailedProps {
  isShow: boolean;
  onRequestClose: () => void;
}

const ModalApprovalFailed: FC<ModalApprovalFailedProps> = ({
  isShow,
  onRequestClose,
}) => {
  return (
    <Modal
      size="sm"
      isShow={isShow}
      title="Service Error"
      onClose={onRequestClose}
      explanation="Unable to Bridge Approval. Please check the service and retry."
      footerComponent={
        <button
          onClick={onRequestClose}
          className="btn btn-block btn-primary btn-lg"
        >
          OK
        </button>
      }
    />
  );
};

export default ModalApprovalFailed;
